import { Controller } from "@hotwired/stimulus"

// Gestisce la griglia di slot di un cassetto: highlight di uno slot a partire
// dal codice prodotto, navigazione al dettaglio slot e zoom della griglia.
export default class extends Controller {
  static targets = ["slot", "grid"]
  static values = { highlight: String, zoom: { type: Number, default: 1 } }

  connect() {
    this.fitToWidth()
    this._onResize = () => this.fitToWidth()
    window.addEventListener("resize", this._onResize)
    if (this.highlightValue) this.applyHighlight()
  }

  disconnect() {
    window.removeEventListener("resize", this._onResize)
  }

  // Dimensione base della cella: riempie tutta la larghezza disponibile,
  // celle quadrate. Lo zoom moltiplica questo valore base.
  fitToWidth() {
    const grid = this.hasGridTarget ? this.gridTarget : this.element
    const cols = parseInt(getComputedStyle(grid).getPropertyValue("--cols")) || 1
    const gap = 1
    const avail = (grid.parentElement?.clientWidth || grid.clientWidth) - 2 // padding/bordo
    this.baseCell = Math.max(12, Math.floor((avail - (cols + 1) * gap) / cols))
    this.applyZoom()
  }

  applyHighlight() {
    const code = this.highlightValue.trim().toUpperCase()
    let first = null
    this.slotTargets.forEach(el => {
      const match = (el.dataset.codice || "").toUpperCase() === code
      el.classList.toggle("highlight", match)
      if (match && !first) first = el
    })
    if (first) first.scrollIntoView({ block: "center", inline: "center", behavior: "smooth" })
  }

  apri(event) {
    const id = event.currentTarget.dataset.slotId
    const cassettoId = this.element.dataset.cassettoId
    if (!id || !cassettoId) return
    Turbo.visit(`/magazzino/cassetti/${cassettoId}?slot=${id}`)
  }

  zoomIn() { this.zoomValue = Math.min(this.zoomValue + 0.25, 3); this.applyZoom() }
  zoomOut() { this.zoomValue = Math.max(this.zoomValue - 0.25, 0.5); this.applyZoom() }

  applyZoom() {
    const base = this.baseCell || 32
    const size = base * this.zoomValue
    const grid = this.hasGridTarget ? this.gridTarget : this.element
    grid.style.setProperty("--cell-w", `${size}px`)
    grid.style.setProperty("--cell-h", `${size}px`)
  }
}
